import { type ReactNode } from 'react'

import { Text } from '@procurify/ui'

import { AiActionBannerStyled } from './styles/AiActionBannerStyled'

interface IAiActionBannerProps {
  action: ReactNode
  children: ReactNode
  icon?: ReactNode
  analyticsId?: string
  isBold?: boolean
}

export const AiActionBanner = ({
  action,
  children,
  icon,
  analyticsId,
  isBold = true,
}: IAiActionBannerProps) => (
  <AiActionBannerStyled
    analyticsId={analyticsId}
    action={action}
    {...(icon !== undefined ? { icon } : {})}
  >
    <Text bold={isBold} breakWord>
      {children}
    </Text>
  </AiActionBannerStyled>
)
